module.exports = __webpack_public_path__ + "img/x10.79983767.jpg";